import React, { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IProduct } from '../../../../../types/types';
import Button from '../../../../../../../../generic-components/Button';
import { ReactComponent as ClearIcon } from '../../../../../../../../assets/icons/svg/shared/ic-shared-clear.svg';
import { TEXTS } from '../../../../../consts/consts';

export const itemNameTemplate = (
  onFocusChange: (isFocused: boolean, target: HTMLInputElement) => void,
  product: IProduct,
  showError: boolean,
  onNameChange: (item: IProduct) => void,
) => {
  const { t } = useTranslation();
  const [isFocused, setIsFocused] = useState<boolean>(false);
  return (
    <div
      className={`flex relative h-[64px] flex-col w-full justify-center hover:${product.serviceItemId ? 'bg-bw0' : 'bg-bw02'} ${isFocused ? 'bg-bw00' : 'bg-bw01'} ${showError ? 'border-[1px] border-red02' : ''}`}
      id={useId()}
    >
      {product.serviceItemId ? (
        <p
          id='selectOrTypeServiceName'
          title={product.name}
          className='font-metricR text-[14px] text-bw07 text-left px-[10px] max-w-[30ch] truncate'
        >
          {product.name}
        </p>
      ) : (
        <div className='flex flex-row justify-between w-full h-full'>
          <input
            onChange={(e) => {
              const input = e.target.value;
              product.name = input.length > 50 ? product.name : input;
              onNameChange(product);
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
            value={product.name}
            placeholder={t(TEXTS.INVOICE_CREATION.INVOICE_SERVICES_SECTION.NAME_INPUT_PLACEHOLDER)}
            className='w-full  bg-transparent py-[10px] px-[10px] outline-none font-metricR font-normal  text-bw08 text-metricR text-[14px] placeholder:text-bw06'
            onFocus={(e) => {
              e.stopPropagation();
              onFocusChange(true, e.target);
              setIsFocused(true);
            }}
            onBlur={() => setIsFocused(false)}
            data-trigger={1}
            id='selectOrTypeServiceName'
            autoComplete='off'
          />
          {product.name.length > 0 && (
            <Button
              className='mr-[8px]'
              id='clear_button'
              childElement={<ClearIcon />}
              onClick={() => {
                product.name = '';
                onNameChange(product);
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};
